<template >
  <div>
    <div class="container-flight margin_container_hf">
      <PDKModal
        :buttonObject="modalButtonProps"
        v-if="showTimerModal"
        @btnAction="onTimeoutModalAction"
      >
        <h3 slot="header">custom header</h3>
        <div style="text-align: center" slot="body">
          <img
            id="timer-logo"
            width="150"
            height="150"
            src="../../../public/img/out-of-ti.png"
          />
          <h4 style="margin-top: 10px">
            {{ $t("SearchResults.TimeOut") }}
          </h4>
        </div>
      </PDKModal>
      <div v-if="hotelList === null"></div>
      <div v-else class="search-box">
        <hotel-search :hotelList="hotelList" :cityList="cityList" />
      </div>
      <div class="row">
        <SKLRoomAside v-if="checkIsAvailableRooms === true" />
        <div
          v-if="Object.keys(hotelDetails).length"
          class="col-lg-6"
          id="single_tour_desc"
        >
          <div class="box_style_1">
            <room-slider :slides="hotelImage" />
          </div>

          <!-- End row  -->
        </div>
        <aside v-if="Object.keys(hotelDetails).length" class="col-lg-6">
          <div class="box_style_1 expose">
            <h3 class="inner">{{ hotelDetails.hotelSummary.name }}</h3>
            <div class="row" style="margin-bottom: 20px">
              <div class="col-md-6">
                <i
                  data-v-1bbc1f64=""
                  aria-hidden="true"
                  class="fa fa-star u-star"
                ></i>
                <i
                  data-v-1bbc1f64=""
                  aria-hidden="true"
                  class="fa fa-star u-star"
                ></i>
                <i
                  data-v-1bbc1f64=""
                  aria-hidden="true"
                  class="fa fa-star u-star"
                ></i>
                <i
                  data-v-1bbc1f64=""
                  aria-hidden="true"
                  class="fa fa-star u-star"
                ></i>
                <i
                  data-v-1bbc1f64=""
                  aria-hidden="true"
                  class="fa fa-star u-star"
                ></i>
              </div>
              <div class="col-md-6" style="float: left"></div>
            </div>

            <div class="row">
              <div class="col-md-12">
                <h4>{{ hotelDetails.hotelSummary.address }}</h4>
              </div>
            </div>
            <div class="row" style="height=400px">
              <!-- <baidu-map class="bm-view"> </baidu-map> -->

              <iframe
                v-if="hotelId === 4"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3569.5129984545083!2d54.02847920298733!3d26.535782878171876!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e50aa4d3b680af9%3A0x5a30586d94d7563d!2sDariush%20Grand%20Hotel!5e0!3m2!1sen!2sus!4v1622543000934!5m2!1sen!2sus"
                width="600"
                height="450"
                style="border: 0"
                allowfullscreen=""
                loading="lazy"
              ></iframe>
              <iframe
                v-if="hotelId === 14"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d804.1520972161971!2d59.618646200322246!3d36.273285385356864!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3f6c972dcb491335%3A0x7072fe1f409f46c4!2sSimorgh%20HOTEL!5e0!3m2!1sen!2sus!4v1622543050830!5m2!1sen!2sus"
                width="600"
                height="450"
                style="border: 0"
                allowfullscreen=""
                loading="lazy"
              ></iframe>
              <iframe
                v-if="hotelId === 9"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1912.5712875021866!2d59.615830226710585!3d36.274734662374534!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3f6c972b5ca0de39%3A0x4c3a8d63c3a2d776!2sSinoor%20Hotel!5e0!3m2!1sen!2sus!4v1622543153058!5m2!1sen!2sus"
                width="600"
                height="450"
                style="border: 0"
                allowfullscreen=""
                loading="lazy"
              ></iframe>
            </div>

            <br />
          </div>
          <div class="box_style_1 expose">
            <div class="row">
              <div class="col-md-6">
                <ul class="list_ok">
                  <li>{{ $t("SearchResults.Elevator") }}</li>
                  <li>{{ $t("SearchResults.ConferenceHall") }}</li>
                  <li>{{ $t("SearchResults.Pool") }}</li>
                  <li>{{ $t("SearchResults.FreeInternetinLobby") }}</li>
                  <li>{{ $t("SearchResults.SafeBox") }}</li>
                  <li>{{ $t("SearchResults.CoveredParking") }}</li>
                  <li>{{ $t("SearchResults.Possibility15") }}</li>
                  <li>{{ $t("SearchResults.TelevisionInLobby") }}</li>
                  <li>{{ $t("SearchResults.NonfreeChildrenArea") }}</li>
                  <li>{{ $t("SearchResults.GymSaloon") }}</li>
                  <li>{{ $t("SearchResults.Jacuzzi") }}</li>
                </ul>
              </div>
              <div class="col-md-6">
                <ul class="list_ok">
                  <li>{{ $t("SearchResults.Massage") }}</li>
                  <li>{{ $t("SearchResults.ItalianRestaurant") }}</li>
                  <li>{{ $t("SearchResults.NonfreeBilliardSaloon") }}</li>
                  <li>{{ $t("SearchResults.WomenHairSaloon") }}</li>
                  <li>{{ $t("SearchResults.TourServices") }}</li>
                  <li>{{ $t("SearchResults.MenHairSaloon") }}</li>
                  <li>{{ $t("SearchResults.CraftSouvenirShop") }}</li>
                  <li>{{ $t("SearchResults.ATM") }}</li>
                </ul>
              </div>
            </div>

            <br />
          </div>
          <!--/box_style_1 -->
        </aside>
        <SKLHotelDetails v-if="checkIsAvailableRooms === true" />

        <div v-if="Object.keys(hotelDetails).length">
          <div class="card p-4 mb-4">
            <div>
              <span class="about-room"
                >{{ $t("About") }} {{ hotelDetails.hotelSummary.name }}</span
              >
              <div style="float: left; font-size: 16px">
                {{ hotelDetails.hotelSummary.name }}
                <span class="room-rank">{{
                  hotelDetails.hotelSummary.StarsCount
                }}</span>
              </div>
            </div>
            <p class="hotel-detail">
              {{ hotelDetails.hotelSummary.generalInfo }}
            </p>
          </div>
        </div>
        <!--End  single_tour_desc-->
      </div>

      <!-- Recommended -->

      <div v-if="eventScheduleList.length > 0" class="box_style_1">
        <h3 class="inner">{{ $t("SearchResults.YourChosenRange") }} !</h3>
        <h6 style="color: #00c3e1">{{ $t("SearchResults.UseThisRange") }}.</h6>
        <hr />

        <div class="row">
          <div
            v-for="(item, indx) in eventScheduleList"
            :key="indx"
            class="col-md-3"
          >
            <a
              @click="goToEvent(item.fromDate, item.toDate)"
              style="cursor: pointer !important; margin-bottom: 5px"
              class="btn_full_outline"
              ><span style="cursor: pointer">{{ item.title }}</span></a
            >
          </div>
        </div>
      </div>

      <div v-else>
        <SKLRoomList v-if="checkIsAvailableRooms === true" />
        <div v-else>
          <Rooms
            v-if="Object.keys(hotelDetails).length"
            @selected="onSelectRoom"
            :roomsAvail="roomsAvail"
            :isDisableButton="isDisableButton"
          />
          <div v-else>
            <RoomNotFound
              @notFoundAction="onHotelNotFound($event)"
              :withoutChangeDate="true"
            >
              <div style="text-align: center" slot="message">
                <img
                  id="timer-logo"
                  width="150"
                  height="150"
                  src="../../../public/img/hotelroom.png"
                />

                <h4 style="margin-top: 10px">
                  {{ $t("SearchResults.SorryFreeRoom") }}
                  <span>{{ $t("SearchResults.NotFound") }}.</span>
                </h4>
              </div>
            </RoomNotFound>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import hotelSearch from "../../components/hotel/HotelSearch";
import Store from "./store/index";
import roomSlider from "../../components/hotel/RoomSlider";
import Rooms from "@/components/hotel/RoomSelector";
import PDKModal from "@/components/PDKAlertModal";
import SKLRoomAside from "../../components/hotel/Skeletons/SKLRoomAside";
import SKLHotelDetails from "../../components/hotel/Skeletons/SKLHotelDetails";
import SKLRoomList from "../../components/hotel/Skeletons/SKLRoomList";
import RoomNotFound from "../../components/tour/HotelNotFound";
export default {
  name: "HotelRooms",
  components: {
    SKLRoomList,
    SKLHotelDetails,
    PDKModal,
    Rooms,
    hotelSearch,
    roomSlider,
    SKLRoomAside,
    RoomNotFound,
  },
  store: Store,

  data() {
    return {
      eventScheduleList: [],
      center: { lng: 35.71067265698085, lat: 51.343631029613306 },
      zoom: 3,
      isDisableButton: false,
      showTimerModal: false,
      roomsAvail: [],
      selectedRoomCount: [],
      numberOfRoomSelected: 0,
      params: {},
      hotelDetails: {},
      hotelList: [],
      cityList: [],
      roomsList: [],
      recommendedRoomList: [],
      showCombineRoom: false,
      tabIndex: 0,
      isShowMore: false,
      localee: "fa",
      showAmenities: {},
      packgeList: [
        {
          id: "0",
          title: "اتاق-صبحانه",
        },
        {
          id: "1",
          title: "پکیج 1",
        },
        {
          id: "2",
          title: "پکیج 2",
        },
        {
          id: "3",
          title: "پکیج 3",
        },
      ],
      disableRoomCount: [],
      roomCount: 0,
      timer: "",
      checkIsAvailableRooms: false,
      hotelImage: [],
      roomImageUrl: "",
      hotelId: 0,
    };
  },
  computed: {
    paginatedRoomsOption() {
      return this.recommendedRoomList;
    },
  },
  async created() {
    this.$store.dispatch("hotel/BookingDetailsEmpty");
    // this.$store.state.bookingDetails={}
    this.getLocationList();
    this.getHotelList();
    this.createRequest();
    this.roomCount = JSON.parse(this.params.rooms).length;
    this.timer = setTimeout(() => {
      this.searchTimeout();

      this.isDisableButton = true;
    }, 600000);

    this.hotelId = this.params.hotelId;
  },
  methods: {
    goToEvent(startDate, endDate) {
      const request = {
        hotelId: this.params.hotelId,
        startDate: startDate,
        endDate: endDate,
        city: this.params.city,
        rooms: this.params.rooms,
      };

      this.$router
        .push({
          name: "hotelrooms",
          query: request,
        })
        .catch(() => {});
    },

    onHotelNotFound() {
      this.$router.push({
        path: "/",
      });
    },
    onTimeoutModalAction() {
      window.location.reload();
    },
    searchTimeout() {
      this.showTimerModal = true;
    },
    onSelectRoom(option) {
      this.$store.dispatch("hotel/SelectedHotelRoom", option);

      const request = {
        hotelId: this.params.hotelId,
        startDate: this.params.startDate,
        endDate: this.params.endDate,
        city: this.params.city,
        rooms: this.params.rooms,
      };

      this.$router
        .push({
          name: "hotelbook",
          query: request,
        })
        .catch(() => {});

      // this.selectedRoom = option;
      // this.skletonModel.isRoom = true;
      // setTimeout(() => {
      //   this.skletonModel.isRoom = false;
      // }, 1200);
    },
    onSelectRoomCount(noAvailbleRoom) {
      if (noAvailbleRoom <= this.roomCount) {
        return noAvailbleRoom;
      } else {
        return this.roomCount;
      }
    },

    onShowAmenities(id) {
      this.$set(this.showAmenities, id, true);
    },
    onHideAmenities(id) {
      this.$set(this.showAmenities, id, false);
    },
    createRequest() {
      this.params = this.$route.query;
      var startDate = this.params.startDate;
      var endDate = this.params.endDate;
      this.getRoomsList(startDate, endDate);
    },

    getRoomsList(startDate, endDate) {
      this.checkIsAvailableRooms = true;
      
      this.$store
      .dispatch("AvailableRoomsCrs", {
        arrivalDate: startDate,
        departureDate: endDate,
        hotelId: this.params.hotelId,
        roomDetails: JSON.parse(this.params.rooms),
        sourceId: localStorage.getItem("SourceIdInReport"),
      })
      .then((res) => {
        this.checkIsAvailableRooms = false;
        if (Object.keys(res.data).length) {
          
          this.hotelDetails = res.data;
          const hotelDetail = {
            hotelDetail: res.data.hotelDetail,
            hotelSummary: res.data.hotelSummary,
            hotelImages: res.data.hotelImages,
            imageURL: res.data.imageURL,
          };
          this.$store.dispatch("hotel/HotelDetails", hotelDetail);
            this.localee = this.$i18n.locale;
               var locale = this.localee;
               hotelDetail.hotelSummary.name = this.$i18n.messages[locale].HotelsList['name' + hotelDetail.hotelSummary.hotelId];
               hotelDetail.hotelSummary.generalInfo = this.$i18n.messages[locale].HotelsList['generalInfo' + hotelDetail.hotelSummary.hotelId];
            var hotelImageUrl = res.data.imageURL;
            
            res.data.hotelImages.forEach((img) => {
              this.hotelImage.push({
                url: hotelImageUrl + img.hotelImageID,
                caption: img.caption,
              });
            });
            console.log("hotel/HotelDetails", hotelDetail);
            this.roomImageUrl = res.data.imageURL.replace("Hotel", "Room");
            this.eventScheduleList = res.data.eventScheduleResponses;
            this.roomsAvail.roomImageUrl = this.roomImageUrl;
            if (this.eventScheduleList.length === 0) {
              this.roomsList = res.data.availableRoomTypes[0][0];
              this.recommendedRoomList = res.data.recommendedRoom;
              this.roomsAvail.availableRoomTypes = res.data.availableRoomTypes;
              this.roomsAvail.availableRooms = res.data.recommendedRoom;
            }
          }
        });
    },
    async getLocationList() {
      this.cityList = await this.$store.dispatch("getLocations");
      this.cityList = this.cityList.filter(
        (p) =>
          p.type == "City" &&
          (p.iata == "KIH" || p.iata == "MHD" || p.iata == "SYZ")
      );
    },
    async getHotelList() {
      const hotelList = await this.$store.dispatch("getHotelList");

      if (Array.isArray(hotelList)) {
        this.mapHotelData(hotelList);
      }
    },
    mapHotelItem(item) {
      const data = {
        englishName: item.title,
        iata: item.location.isoCode,
        node: 0,
        order: 0,
        parentNode: 0,
        persianName: item.title,
        tags: [],
        type: "Hotel",
      };

      return data;
    },
    mapHotelData(hotelList) {
      hotelList.forEach((element) => {
        const data = this.mapHotelItem(element);

        this.hotelList.push(data);
      });
    },
    showMore() {
      this.isShowMore = !this.isShowMore;
    },
  },
};
</script>


<style   scoped >
.price_list {
  margin-left: inherit;
  margin-right: -7px !important;
}
.room_price {
  top: 40px;
  position: absolute;
}

.room_price #detail {
  line-height: 26px;
  direction: ltr;
  font-size: 15px;
  margin-bottom: 11px;
}
.price_res {
  font-weight: bold !important;
  color: #08446a;
}
.container {
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
}
.margin_60 {
  padding-top: 120px;
  padding-bottom: 60px;
}
.search-box {
  position: relative;
  z-index: 9999;
  padding-bottom: 40px;
}

.btn_room {
  background: #f0f7ff;
  color: #0a6c9f;
  width: 205px;
  position: absolute;
  left: 0;
  margin-left: 22px;
}
.btn_room:hover {
  background: #c8e0fa;
  color: #dbb85c;
}

iframe {
  height: 100%;
  width: 100%;
  /* height: 210px; */
}
iframe,
video {
  position: inherit;
  padding-top: 20px;
}

.u-star {
  color: #fcbe2f;
  padding-right: 5px;
}
.rating .voted {
  color: #f90;
}
.rating {
  font-size: 12px;
}
ul.list_ok li:before {
  font-style: normal;
  font-weight: bold;
  font-family: "icon_set_1";
  font-size: 14px;
  content: "\6c";
  color: #e04f67;
  position: absolute;
  left: 0;
  top: 0;
}

.box-frame {
  background-color: #fff;
  border-radius: 5px;
  border: 1px solid #e6e6e6;
  border-top: 0px solid;
  border-radius: 5px;

  margin-bottom: 20px;
  overflow: hidden;
}
.room-card .room-name {
  padding: 10px;
  border-bottom: 1px solid #e6e6e6;
}

.justify-content-between {
  justify-content: space-between !important;
}
@media (min-width: 992px) {
  .flex-lg-row {
    flex-direction: row !important;
  }
}

.align-items-center {
  align-items: center !important;
}
.border-bottom {
  border-bottom: 1px solid #e6e6e6;
}
.room-info-item {
  margin: 0px 10px 0px 10px;
  text-align: center;
}
.room-info i {
  font-size: 25px !important;
}
.room-count {
  margin: 30px 8px 0px 8px;
}
.facility-room {
  margin: 10px 35px 10px 30px;
  /* color: #868686; */
}
ul li div span {
  margin-left: 20px;
  margin-bottom: 20px;
}
ul li div {
  padding-bottom: 8px;
}
.price-content {
  text-align: center;
}
.img-rooms {
  height: 130px;
  /* width: 250px; */
}

.room-title h3 {
  font-size: 14px;
  font-weight: 700;
  color: #08446a;
}
.middle-content-data {
  display: flex;
  font-size: 14px;
  border-left: 1px solid #e5e5e5;
}
.bed {
  float: left;
  text-align: end;
}

.about-room {
  font-size: 20px;
  font-weight: bold;
  color: #00c3e1;
}
.room-rank {
  padding: 4px;
  color: #00c3e2;
  border-radius: 3px;
  margin-right: 3px;
  font-weight: 800;
}
li a i span {
  color: #666;
}
.icon_set_1_icon-61:before {
  content: "\5d";

  font-weight: 600;
  /* color: #0470a7; */
}
.icon_set_1_icon-58:before {
  content: "\5a";
  font-weight: 600;
  /* color: #0470a7; */
}
.select-room {
  background-color: #fff !important;
  border: 1px solid #ced4da;
  border-radius: 3px;
}
.hrcHotel-roomsTitle {
  font-size: 12px;
}
.hrcHotel-roomsTitle p {
  margin: 0px 0 8px 0;
}
.font-weight {
  font-weight: 700;
}
div p span {
  font-weight: 700;
}

.btn_1,
a.btn_1 {
  border: none;
  font-family: inherit;
  font-size: inherit;
  color: #fff;
  background: #008489;
  cursor: pointer;
  padding: 10px 50px;
  display: inline-block;
  outline: 0;
  font-size: 14px;
  -webkit-transition: all 0.3s;
  -moz-transition: all 0.3s;
  transition: all 0.3s;
  -webkit-border-radius: 3px;
  -moz-border-radius: 3px;
  border-radius: 3px;
  font-weight: 700;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fadeIn {
  opacity: 1;
  animation-name: fadeInOpacity;
  animation-iteration-count: 1;
  animation-timing-function: ease-in;
  animation-duration: 0.4s;
}
.fadeOut {
  opacity: 1;
  animation-name: fadeInOpacity;
  animation-iteration-count: 1;
  animation-timing-function: ease-in;
  animation-duration: 0.4s;
}

@keyframes fadeInOpacity {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 0.5;
  }
}
@keyframes fadeOutOpacity {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

.hotle_room_list_desc {
  padding: 10px 20px 10px 20px !important;
  font-size: 14px;
}
.hotel-detail {
  margin-top: 20px;
  font-size: 14px;
  line-height: 30px;
  text-align: justify;
}
.room-desc {
  display: flex;
}
.room-desc #capacity {
  margin: 0px 5px 0px 5px !important;
  color: #898989d1 !important;
  font-size: 15px !important;
}
.room-desc #exterabed {
  margin: 0px 5px 0px 5px !important;
  color: #898989d1 !important;
  font-size: 15px !important;
}
.room {
  display: grid;
  padding: 30px 10px 0px 10px;
}
.room #title {
  font-weight: bold;
  color: #08446a;
}
.room .option {
  margin-bottom: 8px !important;
  color: black;
}
.room-features #title {
  color: #777777;
  line-height: 10px !important;
}
#room-feature {
  margin-top: 8px;
}

.icon-feature {
  font-size: 18px;
  cursor: pointer;
}
.icon-feature:hover {
  font-size: 19px;
  cursor: pointer;
  color: #008489;
}
.bm-view {
  width: 100%;
  height: 300px;
}
</style>

